
import LicenseProto from "./license-proto";
import {License} from "../const/license";
import {ViewType} from "../const/views/view-type";

export default class LicenseFree25 extends LicenseProto {

    constructor(license:License, maxUsers:number) {
        super(license);

        this.name = "Free";

        this.maxUsers = maxUsers;
        this.isPro = false;

        this.prohibitedHomeViews = [ViewType.MY_WORK_WORKLOAD];
        this.prohibitedProjectViews = [ViewType.PROJECT_WORKLOAD, ViewType.PROJECT_GANTT];
        this.prohibitedPortfolioViews = [ViewType.PROJECT_WORKLOAD, ViewType.PROJECT_GANTT];
        this.prohibitedCustomViews = [ViewType.PROJECT_WORKLOAD, ViewType.PROJECT_GANTT];

        this.billingAndFinance = false;
        this.customFields = false;
        this.customTaskTypes = false;

    }

}